import { ChevronLeft, ChevronRight } from "lucide-react";

import SectionHeading from "../../SectionHeading";
import GlobalHeadline from "../../../GlobalHeadline";
import SpotlightCard from "../../SpotlightCard";
import MetricValue from "../../../MetricValue";
import { siteSections } from "../../../../content/siteSections";
import useImpactCarousel from "../../../../hooks/useImpactCarousel";

/**
 * Impact slider section.
 * Translation: Impact slider section.
 *
 * @returns {JSX.Element} Impact section.
 */
const Impact = () => {
  const { nextSlide, previousSlide, itemsPerView, trackStyle, maxIndex, activeIndex } =
    useImpactCarousel(siteSections.impact.cards.length);

  return (
    <section id="impact" className="section-block">
      <div className="section-shell section-shell--wide">
        <SectionHeading
          eyebrow={siteSections.impact.eyebrow}
          title={siteSections.impact.title}
          description={siteSections.impact.description}
        />

        <div className="impact-slider">
          <div className="impact-slider__viewport">
            <div
              className="impact-slider__track"
              style={{
                ...trackStyle,
                width: `${(siteSections.impact.cards.length / itemsPerView) * 100}%`,
              }}
            >
              {siteSections.impact.cards.map((card) => (
                <div
                  key={card.title}
                  className="impact-slider__slide"
                  style={{ width: `${100 / siteSections.impact.cards.length}%` }}
                >
                  <SpotlightCard className="glass-panel section-card impact-card group">
                    <GlobalHeadline as="h3" className="impact-card__title">
                      {card.title}
                    </GlobalHeadline>

                    <div className="impact-card__metric-wrapper">
                      <MetricValue>{card.value}</MetricValue>
                    </div>

                    <p>{card.description}</p>

                    {card.footer && <p className="impact-card__footer">{card.footer}</p>}
                  </SpotlightCard>
                </div>
              ))}
            </div>
          </div>

          <div className="impact-slider__controls">
            <button
              type="button"
              onClick={previousSlide}
              aria-label="Previous impact card"
              disabled={siteSections.impact.cards.length <= itemsPerView}
            >
              <ChevronLeft size={20} />
            </button>
            <button
              type="button"
              onClick={nextSlide}
              aria-label="Next impact card"
              disabled={siteSections.impact.cards.length <= itemsPerView}
            >
              <ChevronRight size={20} />
            </button>
          </div>

          <div className="impact-slider__status" aria-hidden="true">
            {activeIndex + 1}/{maxIndex + 1}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
